"use client";

export default function ArticleContent({ content }) {
  return (
    <div className="prose prose-lg max-w-none mb-6 bg-[#F6F6F6] p-4  rounded-md border-l-2 border-black">
      <p className="text-gray-800 text-[15px] leading-[21px] font-[500]">
        {content}
      </p>
    </div>
  );
}
